export default {
  // タブ
  systemTemplate: 'システムテンプレート',
  myTemplate: 'マイテンプレート',
  // 操作
  customCreate: 'カスタム作成',
  // 空状態
  emptyMyTemplate: 'カスタムテンプレートはありません',
  emptyCanvas: 'コンポーネントをここにドラッグ',
  selectComponentTip: 'キャンバス内のコンポーネントをクリックして編集',
  // エディター
  componentLibrary: 'コンポーネントライブラリ',
  propertyPanel: 'プロパティパネル',
  publicConfig: '公開設定',
  langConfig: '言語設定',
  templateManager: 'テンプレート管理',
  newTemplate: '新規テンプレート',
  cloneTemplate: 'テンプレートを複製',
  deleteTemplate: 'テンプレートを削除',
  templateName: 'テンプレート名',
  templateType: 'テンプレートタイプ',
  supportedLangs: '対応言語',
  // ページ設定
  pageConfig: 'ページ設定',
  pageTitle: 'ページタイトル',
  pageTitlePlaceholder: 'ページタイトルを入力してください',
  canvasConfig: 'キャンバス設定',
  bgColor: '背景色',
  padding: 'パディング',
  styleConfig: 'スタイル設定',
  noStyleConfig: 'このコンポーネントにはスタイル設定がありません',
  // コンポーネント名
  component_carousel: 'カルーセル',
  component_productInfo: '商品情報',
  component_antiFake: '偽造防止情報',
  component_traceability: 'トレーサビリティ情報',
  component_imageGrid: '画像グリッド',
  component_spacer: 'スペーサー',
  component_activityPopup: 'アクティビティポップアップ',
  component_videoPlayer: 'ビデオ',
  component_bottomMenu: 'ボトムメニュー',
};
